/* global fetch */

import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'

import pluralize from 'pluralize'

import { PermissibleButton } from 'components/Permissible'
import { AVATAR_UPLOAD, PERSON, COMPANY } from 'permissions'

import { imageMissing } from 'components/BusinessCard/helpers'

import { ButtonMenu } from '@PipelineDeals/shared-react-components'

const AvatarUploader = ({ record, recordType, callback, children }) => {
  const fileUpload = useRef()
  const policy = useMemo(() => {
    return {
      person: PERSON,
      company: COMPANY
    }[recordType]
  }, [recordType])

  const uploadImage = () => {
    const formData = new FormData()
    formData.append(`${recordType}[image]`, fileUpload.current.files[0])

    fetch(`/${pluralize(recordType)}/${record.id}`, {
      body: formData,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      },
      method: 'PATCH'
    }).then(response => {
      response.json().then(rec => {
        callback(rec)
      })
    })
  }

  const removeImage = () => {
    fetch(`/${pluralize(recordType)}/${record.id}/destroy_avatar`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST'
    }).then(response => {
      response.json().then(rec => {
        callback(rec)
      })
    })
  }

  const renderButton = () => {
    return (
      <a>
        <PermissibleButton action={AVATAR_UPLOAD} cypress={`${recordType}-avatar`} policy={policy}>
          {children}
        </PermissibleButton>
      </a>
    )
  }

  const renderItems = () => {
    return [
      {
        key: 'upload',
        name: 'Upload',
        onClick: () => fileUpload.current.click(),
        allowed: true
      },
      {
        key: 'remove',
        name: 'Remove',
        onClick: removeImage,
        allowed: !imageMissing(record)
      }
    ]
  }

  return (
    <div style={{ flex: 'none', width: '48px' }}>
      <ButtonMenu
        button={renderButton()}
        items={renderItems()}
      />
      <input
        type="file"
        accept="image/*"
        ref={fileUpload}
        onChange={uploadImage}
        hidden
      />
    </div>
  )
}

AvatarUploader.propTypes = {
  callback: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  record: PropTypes.object.isRequired,
  recordType: PropTypes.string.isRequired
}

export default AvatarUploader
